import React from "react";

import { ReactComponent as SupportSvg } from '../assets/support.svg';
import { ReactComponent as QuestionSvg } from '../assets/question.svg';
import { ReactComponent as EventSvg } from '../assets/event_small.svg';
import { ReactComponent as NotificationSvg } from '../assets/notification.svg'; 
import { ReactComponent as PersonSvg } from '../assets/person.svg';
import { ReactComponent as HomeSvg } from '../assets/home.svg';


export default function Footer() {
    
    return (
        
        <>
        
            <div className="mobile-show fixed-menu">
                
                <div className="home active">
                    <div className="menu-icon"><HomeSvg/></div>
                    <div>Home</div>
                </div>   
                <div className="event">
                    <div className="menu-icon"><EventSvg /></div>
                    <div>Event</div>
                </div>
                <div className="notifications">
                    <div className="menu-icon active"><NotificationSvg /></div>
                    <div>Notice</div>
                </div>
                <div className="user">
                    <div className="menu-icon"><PersonSvg/></div>
                    <div>Profile</div>
                </div>            
            
            </div>
        
            <footer>        
                <div className="content">
                    <div className="support">
                        <SupportSvg />
                        Technical support
                    </div>
                    <div className="question">
                        <QuestionSvg />
                        Ask a question
                    </div>                                
                </div>            
            </footer>
            
        </>
        
    )
        
}

